import React, { Component, useState, useEffect } from 'react';
import authService from './api-authorization/AuthorizeService'
import { Route, Link } from "react-router-dom";
import MyModal from "../components/MyModal";
import LinkButton from '../components/LinkButton';
import * as $ from 'jquery'
import * as MySound from '../components/MySound';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../components/GlobalContext';

export const UnloadTruck = (props) => {
    const [state, setState] = useState(reset());
    let txtID = null;

    function reset(saveState) {
        let defaultState = { palletText: "", headerTitle: "Scan Pallet ID", sending: false };
        if (saveState)
            setState(defaultState);
        else
            return defaultState;
    }
    useEffect(() => {
        txtID.focus();
    });
    function txtKeyPressed(e) {
        if (e?.which == 13) {
            var newState = { ...state };
            if (newState.palletText.length > 0) {
                newState.headerTitle = MyGlobal.strings.sending;
                newState.sending = true;
                setState(newState);
            }
        }
    }

    async function sendTruckUnLoad() {
        //   const token = await authService.getAccessToken();
        let userID = MyGlobal.user;
        let url = `api/Tote/ClientMoveTruckUnload?palletID=${state.palletText}&userID=${userID}`;

        const response = await fetch(url, {
        //      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        if (data.length > 0) {
            MySound.play(MySound.Sound.next);
        } else {
            MySound.play(MySound.Sound.stop);
        }
        reset(true);
    }

    if (state.sending)
        sendTruckUnLoad();

    return (<div className="container">
        <MyHeading>{state.headerTitle}</MyHeading>
        <div className="form-group">
            <div className="input-group">
                <input className="form-control"
                    type="text"
                    value={state.palletText}
                    onChange={(e) => {
                        let newState = { ...state };
                        newState.palletText = e.target.value;
                        setState(newState);
                    }}
                    onKeyPress={(e) => {
                        txtKeyPressed(e);
                    }}
                    readOnly={state.sending}
                    name="txtID"
                    id="txtID"
                    autoFocus
                    ref={(input) => { txtID = input; }}
                />

            </div>
        </div>
        <button className="btn btn-success col-12 mb-2" disabled={state.sending} onClick={() => { reset(true); }}>Refresh</button>
    </div>)


}
